import { useEffect } from 'react';
import { usePostHog } from '@posthog/react';
import { betaNavStatus } from './betaNavPreference';

export type NavVersion = 'side_nav' | 'original';

export const useNavVersionProperty = (sideNavEnabled: boolean, enrolled: boolean): void => {
  const posthog = usePostHog();

  useEffect(() => {
    posthog?.register({ nav_version: sideNavEnabled ? 'side_nav' : 'original' });
  }, [posthog, sideNavEnabled]);

  useEffect(() => {
    if (!enrolled) return;

    posthog?.setPersonProperties({ side_nav_beta_status: betaNavStatus() });
  }, [posthog, enrolled, sideNavEnabled]);
};
